<script lang="ts">
    import {Icon} from 'svelma';

    export let scale;
    export let focus;
    export let passLeft;
    export let passRight;
    export let setFocus;
</script>

<div class="indexer position width">
    <div class="columns is-gapless m-0">
        <div class="column is-narrow">
            {#each Array(scale) as _,i}
                <div on:click={()=>setFocus(i)} class="circle" class:highlight={i===focus}></div>
            {/each}
        </div>
        <div class="column"></div>
    </div>
    <div class="columns is-gapless">
        <div class="column is-narrow">
            <div class="arrow" on:click={passLeft}>
                <Icon type="is-primary" pack="fa" size="is-small" icon="arrow-left"/>
            </div>
        </div>
        <div class="column"></div>
        <div class="column is-narrow">
            <div class="arrow" on:click={passRight}>
                <Icon type="is-primary" pack="fa" size="is-small" icon="arrow-right"/>
            </div>
        </div>
    </div>


</div>

<style>

    .width{width: 100%}

    .arrow{opacity: 0.5; height:30px}

    .arrow:hover{
        opacity: 1;
        cursor: pointer;
        transform: scale(1.2);
    }

    .position{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 31;
    }

    .highlight{
        background-color: #3fe1c9 !important;
        border: 1px solid #00b99e !important;
    }

    .circle{
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 25px;
        border: 1px solid #c7c7c7;
        background-color: #dbdbdb;
        margin-left: 5px;
    }
    
    .circle:hover{
        cursor: pointer;
        background-color: #a9ffee;
    }
</style>